import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from 'core/services/auth/authorization.service';
import { NavigationService } from 'core/services/navigation.service';

export abstract class BaseNavigationGuard {
  protected router = inject(Router);
  protected navigationService = inject(NavigationService);
  protected authorizationService = inject(AuthorizationService);

  protected canAccessRoute(menuIdentifier: string, specificRoles?: number[]): boolean {
    if (this.authorizationService.isSuperAdmin()) {
      return true;
    }

    if (specificRoles && specificRoles.length > 0) {
      const hasSpecificRole = this.authorizationService.checkSiteRoles(specificRoles);
      if (!hasSpecificRole) {
        this.redirectToHome();
        return false;
      }
    }

    const menuItem = this.navigationService.menuRoles.find(
      (menuRole) => menuRole.menu.toLowerCase() === menuIdentifier.toLowerCase()
    );

    if (!menuItem) {
      this.redirectToHome();
      return false;
    }

    const hasRequiredRole = this.authorizationService.checkSiteRoles(menuItem.roleIds);

    if (!hasRequiredRole) {
      this.redirectToHome();
      return false;
    }

    return true;
  }

  private redirectToHome(): void {
    this.router.navigate(['/home']);
  }
}
